import { Root } from './Root'
import { Description } from './Description'
import { Action } from './Action'
import { Details } from './Details'
import { Icon } from './Icon'
import { message } from 'antd'
import { ReactNode } from 'react'

export const Toast = {
  Root,
  Icon,
  Description,
  Action,
  Details,
}

export const showToast = (Message: ReactNode, durationInSeconds: number, key?: string, onClose?: () => void) => {
  return message.success({
    content: Message,
    key,
    duration: durationInSeconds,
    type: 'success',
    onClose,
  })
}
